import { render, staticRenderFns } from "./WebhookIcon.vue?vue&type=template&id=09b64cf6&"
import script from "./WebhookIcon.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WebhookIcon.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports